import firebase from 'firebase/app';

export default class FirebaseConfig {
  
  firebaseCredentials() {
    let database = "https://pargolfsolutions-e4659-default-rtdb.firebaseio.com"
    if(process.env.VUE_APP_FIREBASE_ENV == "development"){
    database = "http://54.215.97.142:50042?ns=pargolfsolutions-e4659-default-rtdb"
    }
    return {
    apiKey: "AIzaSyDxhE476jZUhIcJIAiWLDAhUuvHQ8NxGiY",
    authDomain: "pargolfsolutions-e4659.firebaseapp.com",
    projectId: "pargolfsolutions-e4659",
    databaseURL: database,
    storageBucket: "pargolfsolutions-e4659.appspot.com",
    messagingSenderId: "676981839003",
    appId: "1:676981839003:web:12a849e36faec2c6dba23e",
    measurementId: "G-EC74PYSX3L"}
  }

  firebaseInitMainApp() {
    if (!firebase.apps.length) {
    firebase.initializeApp(this.firebaseCredentials());
    }
  }

  async getUrlDatabaseByTenant(tenant){
    let mainApp = await this.getApp()
    const dbFireConfig   =  new firebase.database(mainApp);
    let dataValue = await dbFireConfig.ref(`${tenant}/databaseURL`).once("value");
    if(dataValue.exists()){
      return {ok:true,urlDatabase:dataValue.val(),tenant:tenant}
    }else{
      return {ok:false};
    }
  }

  async getUserTenantByUserType(tenant,userType){
    let mainApp = await this.getApp()
    const dbFireConfig   =  new firebase.database(mainApp);
    let dataValue = await dbFireConfig.ref(`${tenant}/AuthTenants/${userType}`).once("value");
    if(dataValue.exists()){
      return {ok:true,userTenant:dataValue.val()}
    }else{
      return {ok:false};
    }
  }

  async getApp(tenant,urlDatabase,credentialParam){
      try{
      
        return firebase.app(tenant);
        
      }catch(e){
        
        if(this.isFirebaseError(e,"app/no-app")){
             if (tenant) {
              try{
                let tenantInfo = await this.getUrlDatabaseByTenant(tenant);
                return firebase.initializeApp({
                  ...firebase.app().options,
                  databaseURL: tenantInfo.urlDatabase
                },tenant);
              }catch(e){
                if(this.isFirebaseError(e,"app/duplicate-app")){
                  return firebase.app(tenant);
                }
              }
            }
        }
      }
  }
  

  isFirebaseError(err,err_code){

      if (typeof err.code === "string" ) {
        if (!err_code || err.code === err_code) {
          return true;
        }
      }
    
    return false;
  }


  setTenantInLocal(Tenant){
    localStorage.setItem('ParGolfTenant',Tenant );
  }

  getTenantInLocal(){
    return localStorage.getItem('ParGolfTenant')
  }


  
}







